<template>
  <div class="slider-alert">
    <div class="alert alert-danger" role="alert" style="min-height: 70px;">
      <div class="container">
        <div class="row">
          <div class="col-sm-7">{{ $t('javascript.framework_changed') }}</div>
          <div class="col-sm-4"><a class="btn btn-danger" :href="'/cases/' + caseId + '/framework'">{{ $t('javascript.review_the_framework') }}</a></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "s-alert",
    props: [
      'caseId'
    ]
  }
</script>
